export default __webpack_public_path__ + "static/media/dolar.daed1ce2.jpg";